import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const dict = {
    tr: {
        // common
        "common.search": "Ara…",
        "common.copy": "Kopyala",
        "common.copied": "Kopyalandı",
        "common.save": "Kaydet",
        "common.cancel": "Vazgeç",
        "common.create": "Oluştur",
        "common.continue": "Devam Et",
        "common.verify": "Doğrula",
        "common.resend": "Kodu Tekrar Gönder",
        "common.back": "Geri",
        "common.new": "Yeni",
        "common.active": "Aktif",
        "common.draft": "Taslak",
        "common.paused": "Duraklatıldı",
        // nav
        "nav.dashboard": "Genel Bakış",
        "nav.analytics": "Analitik",
        "nav.sizing-panel": "Sayz Widget",
        "nav.size-chart-modal": "Beden Tablosu",
        "nav.find-my-size-wizard": "Bedenimi Bul",
        "nav.products": "Ürünler",
        "nav.tables": "Tablolar",
        "nav.size-series": "Beden Serileri",
        "nav.measurement-groups": "Ölçü Grupları",
        "nav.fit-info": "Kalıp Bilgileri",
        "nav.models": "Modeller",
        "nav.images": "Görseller",
        "nav.settings": "Ayarlar",
        "nav.integration": "Entegrasyon",
        "nav.license": "Lisans",
        "nav.section.workspace": "Panel",
        "nav.section.experiences": "Deneyimler",
        "nav.section.widgets": "Widget",
        "nav.section.catalog": "Katalog",
        "nav.section.sizing": "Yapılandırma",
        "nav.section.security": "Güvenlik",
        "nav.section.system": "Sistem",
        "nav.backups": "Yedekler",
        "nav.trash": "Çöp Kutusu",
        "nav.audit": "Etkinlik Kaydı",
        // login
        "login.welcome": "Tekrar hoş geldin",
        "login.subtitle": "Sayz hesabınla devam etmek için e-posta adresini gir.",
        "login.email": "E-posta",
        "login.placeholder": "isim@sirket.com",
        "login.invitedOnly": "Sayz davete özel bir paneldir. Sadece tanımlı kullanıcılar giriş yapabilir.",
        "login.otp.title": "Doğrulama kodu",
        "login.otp.subtitle": "{email} adresine 6 haneli kodu gönderdik. Kodun geçerlilik süresi 5 dakikadır.",
        "login.otp.resentIn": "Yeniden gönder ({s}s)",
        "login.otp.invalid": "Kod hatalı. Lütfen tekrar deneyin.",
        // dashboard
        "dash.title": "Genel Bakış",
        "dash.subtitle": "Tüm widget'larınızın bugünkü performansı.",
        "dash.range.7d": "Son 7 gün",
        "dash.range.30d": "Son 30 gün",
        "dash.range.90d": "Son 90 gün",
        "dash.kpi.views": "Widget gösterimleri",
        "dash.kpi.interactions": "Etkileşimler",
        "dash.kpi.completed": "Tamamlanan beden bulma",
        "dash.kpi.returns": "Önlenen iadeler",
        "dash.chart.title": "Gösterimler ve etkileşimler",
        "dash.chart.subtitle": "Saatlik dağılım",
        "dash.funnel.title": "Dönüşüm hunisi",
        "dash.funnel.step1": "Widget açıldı",
        "dash.funnel.step2": "İlk etkileşim",
        "dash.funnel.step3": "Soruları tamamladı",
        "dash.funnel.step4": "Öneri görüntülendi",
        "dash.funnel.step5": "Satın aldı",
        "dash.activity.title": "Son etkinlikler",
        "dash.activity.all": "Tümü",
        "dash.topwidgets.title": "En iyi performans",
        "dash.topwidgets.range": "Bu hafta",
        "dash.download": "Rapor İndir",
        "dash.funnel.totalSuffix": "toplam etkileşim",
        "activity.published": "Widget yayınlandı",
        "activity.storeConnected": "Yeni mağaza bağlandı",
        "activity.findCompleted": "Beden bulma tamamlandı",
        "activity.paused": "Widget duraklatıldı",
        "activity.questionAdded": "Yeni soru eklendi",
        // widgets
        "widgets.title": "Widget'lar",
        "widgets.subtitle": "Tüm beden tablosu ve bedenimi bul deneyimlerin.",
        "widgets.create": "Yeni widget",
        "widgets.col.name": "Widget",
        "widgets.col.type": "Tür",
        "widgets.col.store": "Mağaza",
        "widgets.col.status": "Durum",
        "widgets.col.views": "Gösterim",
        "widgets.col.updated": "Son düzenleme",
        "widgets.type.sizetable": "Beden tablosu",
        "widgets.type.findmysize": "Bedenimi bul",
        // editor
        "editor.preview": "Canlı önizleme",
        "editor.publish": "Yayınla",
        "editor.unsaved": "Kaydedilmemiş değişiklikler",
        "editor.size.title": "Beden tablosu",
        "editor.size.columns": "Ölçü sütunları",
        "editor.size.rows": "Beden satırları",
        "editor.size.unit": "Ölçü birimi",
        "editor.fms.title": "Bedenimi bul",
        "editor.fms.steps": "Akış adımları",
        "editor.fms.addstep": "Adım ekle",
        // embed
        "embed.title": "Embed script",
        "embed.subtitle": "Sayz widget'ını mağazana eklemek için aşağıdaki kodu </body> etiketinden hemen önce yapıştır.",
        "embed.step1": "Kodu kopyala",
        "embed.step2": "Mağazana yapıştır",
        "embed.step3": "Bağlantıyı doğrula",
        "embed.status.waiting": "Sinyal bekleniyor",
        "embed.status.installed": "Bağlantı kuruldu",
        // stores
        "stores.title": "Mağazalar",
        "stores.subtitle": "Sayz'a bağlı tüm e-ticaret siteleriniz.",
        "stores.connect": "Mağaza bağla",
        // analytics
        "analytics.title": "Analitik",
        "analytics.subtitle": "Beden önerileri ve dönüşüm metrikleri.",
        "analytics.recommended": "En çok önerilen bedenler",
        "analytics.geo": "Ülke bazlı dönüşüm",
        // settings
        "settings.title": "Ayarlar",
        "settings.subtitle": "Hesap ve ekip yapılandırması.",
        "settings.tabs.profile": "Profil",
        "settings.tabs.team": "Ekip",
        // integration (yeni menü)
        "integration.title": "Entegrasyon",
        "integration.subtitle": "Mağaza bağlantısı, kurulum sağlığı ve XML katalog yapılandırması.",
        "integration.tabs.installation": "Kurulum",
        "integration.tabs.xml": "XML Bağlantısı",
        // license (yeni bağımsız sayfa)
        "license.title": "Lisans",
        "license.subtitle": "Aboneliğin ve deneme sürecinin durumu.",
        // profile
        "settings.profile.title": "Profil",
        "settings.profile.desc": "Hesap bilgilerin diğer ekip üyelerine görünür.",
        "settings.profile.name": "Ad Soyad",
        "settings.profile.email": "E-posta",
        "settings.profile.role": "Rol",
        "settings.profile.company": "Şirket",
        "settings.profile.save": "Değişiklikleri Kaydet",
        "settings.profile.saved": "Profil güncellendi",
        "role.owner": "Hesap Sahibi",
        "role.member": "Ekip Üyesi",
        // license
        "settings.license.title": "Demo erişim",
        "settings.license.trialBadge": "Deneme",
        "settings.license.activeBadge": "Aktif",
        "settings.license.expiredBadge": "Süresi doldu",
        "settings.license.duration": "Deneme süresi",
        "settings.license.days": "gün",
        "settings.license.daysUsed": "gün kullanıldı",
        "settings.license.endsAt": "Bitiş",
        "settings.license.startedAt": "Başlangıç",
        "settings.license.activatedAt": "Aktifleşme",
        "settings.license.notEnded": "Deneme bitiminde widget'larınız otomatik olarak duraklatılır ve mağazanızda görünmez. Sözleşme imzası sonrası Sayz ekibi lisansınızı aktifleştirir, kaldığınız yerden devam edersiniz.",
        "settings.license.processTitle": "Lisanslama süreci",
        "settings.license.processDesc": "Sayz davete özel bir SaaS'tır. Süreciniz aşağıdaki adımlardan geçer.",
        "license.step.meeting": "Toplantı",
        "license.step.meeting.desc": "Ürün ihtiyaç analizi ve ilk görüşme.",
        "license.step.demo": "Demo",
        "license.step.demo.desc": "Süper admin tarafından e-postanızla panel erişiminiz açıldı.",
        "license.step.contract_talk": "Sözleşme Görüşmesi",
        "license.step.contract_talk.desc": "Hukuki çerçeve ve fiyatlandırma netleştirilir.",
        "license.step.contract_signed": "Sözleşme İmzası",
        "license.step.contract_signed.desc": "İmzalı sözleşmenin Sayz'a ulaşması.",
        "license.step.billing_active": "Faturalandırma & Aktivasyon",
        "license.step.billing_active.desc": "Fatura kesimi sonrası lisans aktifleştirilir.",
        "license.step.inProgress": "Devam ediyor",
        "license.step.pending": "Bekleniyor",
        // xml integration
        "settings.xml.title": "XML Entegrasyonu",
        "settings.xml.desc": "Mağazanızın ürünlerini XML feed üzerinden panele aktarın.",
        "settings.xml.comingSoon": "Yakında",
        "settings.xml.comingSoonDesc": "Bu bölüm, mağazanızın ürün kataloğunu XML feed URL'i ile panele bağlamanızı sağlayacak. Feed 6 saatte bir senkronize edilir, ürünler SKU üzerinden eşleştirilir. Şu anda geliştirme aşamasındadır.",
    },
    en: {
        "common.search": "Search…",
        "common.copy": "Copy",
        "common.copied": "Copied",
        "common.save": "Save",
        "common.cancel": "Cancel",
        "common.create": "Create",
        "common.continue": "Continue",
        "common.verify": "Verify",
        "common.resend": "Resend code",
        "common.back": "Back",
        "common.new": "New",
        "common.active": "Active",
        "common.draft": "Draft",
        "common.paused": "Paused",
        "nav.dashboard": "Overview",
        "nav.analytics": "Analytics",
        "nav.sizing-panel": "Sayz Widget",
        "nav.size-chart-modal": "Size Chart",
        "nav.find-my-size-wizard": "Find My Size",
        "nav.products": "Products",
        "nav.tables": "Tables",
        "nav.size-series": "Size Series",
        "nav.measurement-groups": "Measurement Groups",
        "nav.fit-info": "Fit Info",
        "nav.models": "Models",
        "nav.images": "Images",
        "nav.settings": "Settings",
        "nav.integration": "Integration",
        "nav.license": "License",
        "nav.section.workspace": "Panel",
        "nav.section.experiences": "Experiences",
        "nav.section.widgets": "Widget",
        "nav.section.catalog": "Catalog",
        "nav.section.sizing": "Configuration",
        "nav.section.system": "System",
        "login.welcome": "Welcome back",
        "login.subtitle": "Enter the email of your Sayz account to continue.",
        "login.email": "Email",
        "login.placeholder": "name@company.com",
        "login.invitedOnly": "Sayz is invite-only. Only seats provisioned by your admin can sign in.",
        "login.otp.title": "Verification code",
        "login.otp.subtitle": "We've sent a 6-digit code to {email}. It expires in 5 minutes.",
        "login.otp.resentIn": "Resend in ({s}s)",
        "login.otp.invalid": "Invalid code. Please try again.",
        "dash.title": "Overview",
        "dash.subtitle": "Today's performance across all of your widgets.",
        "dash.range.7d": "Last 7 days",
        "dash.range.30d": "Last 30 days",
        "dash.range.90d": "Last 90 days",
        "dash.kpi.views": "Widget views",
        "dash.kpi.interactions": "Interactions",
        "dash.kpi.completed": "Completed size finds",
        "dash.kpi.returns": "Returns avoided",
        "dash.chart.title": "Views vs interactions",
        "dash.chart.subtitle": "Hourly breakdown",
        "dash.funnel.title": "Conversion funnel",
        "dash.funnel.step1": "Widget opened",
        "dash.funnel.step2": "First interaction",
        "dash.funnel.step3": "Completed questions",
        "dash.funnel.step4": "Saw recommendation",
        "dash.funnel.step5": "Purchased",
        "dash.activity.title": "Recent activity",
        "dash.activity.all": "All",
        "dash.topwidgets.title": "Top performers",
        "dash.topwidgets.range": "This week",
        "dash.download": "Download Report",
        "dash.funnel.totalSuffix": "total interactions",
        "activity.published": "Widget published",
        "activity.storeConnected": "Store connected",
        "activity.findCompleted": "Size find completed",
        "activity.paused": "Widget paused",
        "activity.questionAdded": "Question added",
        "widgets.title": "Widgets",
        "widgets.subtitle": "All your size-table and find-my-size experiences.",
        "widgets.create": "New widget",
        "widgets.col.name": "Widget",
        "widgets.col.type": "Type",
        "widgets.col.store": "Store",
        "widgets.col.status": "Status",
        "widgets.col.views": "Views",
        "widgets.col.updated": "Last edited",
        "widgets.type.sizetable": "Size table",
        "widgets.type.findmysize": "Find my size",
        "editor.preview": "Live preview",
        "editor.publish": "Publish",
        "editor.unsaved": "Unsaved changes",
        "editor.size.title": "Size table",
        "editor.size.columns": "Measurement columns",
        "editor.size.rows": "Size rows",
        "editor.size.unit": "Unit",
        "editor.fms.title": "Find my size",
        "editor.fms.steps": "Flow steps",
        "editor.fms.addstep": "Add step",
        "embed.title": "Embed script",
        "embed.subtitle": "Paste this snippet right before the </body> tag of your store to install Sayz.",
        "embed.step1": "Copy the snippet",
        "embed.step2": "Paste it on your store",
        "embed.step3": "Verify connection",
        "embed.status.waiting": "Waiting for signal",
        "embed.status.installed": "Connected",
        "stores.title": "Stores",
        "stores.subtitle": "All e-commerce sites connected to Sayz.",
        "stores.connect": "Connect store",
        "analytics.title": "Analytics",
        "analytics.subtitle": "Size recommendation and conversion metrics.",
        "analytics.recommended": "Most recommended sizes",
        "analytics.geo": "Conversion by country",
        "settings.title": "Settings",
        "settings.subtitle": "Account and team configuration.",
        "settings.tabs.profile": "Profile",
        "settings.tabs.team": "Team",
        // integration (new menu)
        "integration.title": "Integration",
        "integration.subtitle": "Store connection, setup health and XML catalog configuration.",
        "integration.tabs.installation": "Installation",
        "integration.tabs.xml": "XML Connection",
        // license (new standalone page)
        "license.title": "License",
        "license.subtitle": "Status of your subscription and trial process.",
        "settings.profile.title": "Profile",
        "settings.profile.desc": "Your account info is visible to other team members.",
        "settings.profile.name": "Full name",
        "settings.profile.email": "E-mail",
        "settings.profile.role": "Role",
        "settings.profile.company": "Company",
        "settings.profile.save": "Save Changes",
        "settings.profile.saved": "Profile updated",
        "role.owner": "Account Owner",
        "role.member": "Team Member",
        "settings.license.title": "Demo access",
        "settings.license.trialBadge": "Trial",
        "settings.license.activeBadge": "Active",
        "settings.license.expiredBadge": "Expired",
        "settings.license.duration": "Trial duration",
        "settings.license.days": "days",
        "settings.license.daysUsed": "days used",
        "settings.license.endsAt": "Ends",
        "settings.license.startedAt": "Started",
        "settings.license.activatedAt": "Activated",
        "settings.license.notEnded": "When the trial ends, your widgets are automatically paused. After contract signature, the Sayz team activates your license.",
        "settings.license.processTitle": "Licensing process",
        "settings.license.processDesc": "Sayz is an invite-only SaaS. Your onboarding follows the steps below.",
        "license.step.meeting": "Meeting",
        "license.step.meeting.desc": "Product needs analysis and first call.",
        "license.step.demo": "Demo",
        "license.step.demo.desc": "Panel access opened by superadmin.",
        "license.step.contract_talk": "Contract Discussion",
        "license.step.contract_talk.desc": "Legal framework and pricing.",
        "license.step.contract_signed": "Contract Signed",
        "license.step.contract_signed.desc": "Signed contract delivered to Sayz.",
        "license.step.billing_active": "Billing & Activation",
        "license.step.billing_active.desc": "License activated after invoicing.",
        "license.step.inProgress": "In progress",
        "license.step.pending": "Pending",
        "settings.xml.title": "XML Integration",
        "settings.xml.desc": "Import your store's products via XML feed.",
        "settings.xml.comingSoon": "Coming soon",
        "settings.xml.comingSoonDesc": "This section will let you connect your product catalog via an XML feed URL. Under development.",
    },
};

const I18nContext = createContext({ lang: "tr", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "tr";
        return localStorage.getItem("sayz-lang") || "tr";
    });

    useEffect(() => {
        localStorage.setItem("sayz-lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const setLang = useCallback((l) => setLangState(l), []);

    const t = useCallback((key, vars) => {
        const raw = (dict[lang] && dict[lang][key]) || (dict.en && dict.en[key]) || key;
        if (!vars) return raw;
        return Object.keys(vars).reduce((acc, k) => acc.replace(`{${k}}`, vars[k]), raw);
    }, [lang]);

    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
